import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const CALENDAR_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calendar'),
    name: 'calendar',
    meta: {
      permissions: CALENDAR_PERMISSIONS,
      featureFlag: FEATURE_FLAGS.CALENDAR,
    },
    component: () => import('./CalendarView.vue'),
  },
];
